import "../stylesheets/partner_portal.scss";
import "../stylesheets/availability_visualisation.scss";
import "../src/partner_cable";

// Configure Stimulus
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "../controllers/register_controllers";

const application = Application.start();
const controllers = import.meta.glob("../controllers/{partner_portal,shared}/**/*", { eager: true })
registerControllers(application, controllers)
